const questionsItems = document.querySelectorAll('.question__item')
const sectionsDom = document.querySelectorAll('section');
const resultPizzaItems = document.querySelectorAll('.result__decoration-pizza');

questionsItems.forEach(item => {
  item.addEventListener("click", () => {
    item.classList.toggle('active')
  })
})

document.querySelector('.twenty-years-landing')?.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
});

const observer = new IntersectionObserver((sections) => {
  sections.forEach(section => {
    if (section.isIntersecting) {
      section.target.classList.add('show-anim')
    }
  })
}, {
  threshold: .1
});

sectionsDom.forEach(section => {
  observer.observe(section)
})

window.onscroll = () => {
  resultPizzaItems.forEach((pizza, index) => {
    let prepareIndex = index + 10

    if (index == 1) {
      prepareIndex = -prepareIndex
    }

    let y = window.innerHeight - pizza.getBoundingClientRect().top
    pizza.style.transform = 'translate3d(0, -' + (0.03 * y * Math.abs(prepareIndex)) + 'px ,0) rotate(' + y * prepareIndex * 0.005 + 'deg)'
  })
}

window.addEventListener('load', () => {
  if (!document.querySelector('.swiper')) {
    return;
  }
  new Swiper('.swiper', {
    spaceBetween: 10,
    slidesPerView: 1,
    breakpoints: {
      1200: {
        slidesPerView: 3,
        spaceBetween: 'auto',
      }
    },
  });
})
